module.exports = __webpack_public_path__ + "img/chengli1.da4df223.png";